import { createFailure } from '../OperationResult.js';
import { tryExecuteSimple } from '../tryExecuteSimple.js';
import { importWidgetModuleFromNamespace, } from './importWidgetModuleFromNamespace.js';
export var ImportWidgetModuleFaultType;
(function (ImportWidgetModuleFaultType) {
    ImportWidgetModuleFaultType["InvalidArguments"] = "invalid-arguments";
})(ImportWidgetModuleFaultType || (ImportWidgetModuleFaultType = {}));
function createImportFailure(type, message) {
    return createFailure({ type, message });
}
export async function importWidgetModule({ widgetUrl, dependencies, }) {
    if (!widgetUrl) {
        return createImportFailure(ImportWidgetModuleFaultType.InvalidArguments, `Widget url '${widgetUrl}' is invalid`);
    }
    if (!dependencies) {
        return createImportFailure(ImportWidgetModuleFaultType.InvalidArguments, `Dependencies '${dependencies}' are not object`);
    }
    const namespaceResult = await tryExecuteSimple(() => import(/* webpackIgnore: true */ widgetUrl));
    return await importWidgetModuleFromNamespace(namespaceResult, widgetUrl, dependencies);
}
